// VideoBrandFrame — kept as a thin re-export wrapper around the
// canonical `BrandMonogramEdge` component so existing imports
// (`VideoSection.jsx` and any other historical callers) keep working
// without changes. The branded watermark logic now lives in
// `BrandMonogramEdge.jsx` and is shared between video placeholders and
// every page hero across the site.

import BrandMonogramEdge from "@/components/BrandMonogramEdge";

export default BrandMonogramEdge;
